import { BundlrStorageDriver } from './BundlrStorageDriver.mjs';

const bundlrStorage = (options = {}) => ({
  install(metaplex) {
    metaplex.storage().setDriver(new BundlrStorageDriver(metaplex, options));
  }

});

export { bundlrStorage };
//# sourceMappingURL=plugin.mjs.map
